import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { setTranslations, setDefaultLanguage, withTranslation } from 'react-multi-lang'
import { useTranslation } from 'react-multi-lang'
export const AuthContext = createContext();
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`
export const AuthContextProvider = ({ children }) => {
  const [lang, setLang] = useState('ua')
  const t = useTranslation()
  const [currentUser, setCurrentUser] = useState(
     {
      ID_user:0,
      email:null,
      phone_number:null,
      category:"u",
      firstName:null,
      lastName:null,
      img:null,
      address:null,
      data:null,
      type:null
    }
  );
  
  useEffect(()=>{
    setDefaultLanguage(lang)
},[lang])

  const login = async (inputs) => {
    try{ 
    const res = await axios.post(`${SERVER}/api/auth/login`, inputs, {
      withCredentials: true,
    });
  
    setCurrentUser(res.data)
    console.log(res)
  }catch(e){
    console.log("************catch*********")
    alert(e.response.data.err)
  }
  };

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(currentUser));
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, login ,setCurrentUser,lang,setLang,t}}>
      {children}
    </AuthContext.Provider>
  );
};
